import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";

export default function StickyMobileCTA({ onBook }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.35 }}
          className="md:hidden fixed bottom-3 left-3 right-3 z-40"
          data-testid="sticky-mobile-cta"
        >
          <div className="glass-strong rounded-2xl p-2.5 flex items-center gap-2">
            <div className="flex-1 pl-2">
              <div className="text-[10px] uppercase tracking-widest text-[#A7D38B]">From ₹699</div>
              <div className="text-xs text-neutral-300">Book in &lt; 60 seconds</div>
            </div>
            <button
              onClick={onBook}
              data-testid="sticky-book-btn"
              className="inline-flex items-center gap-2 rounded-xl bg-[#62794d] text-[#f5f0ea] px-4 py-2.5 text-sm font-semibold active:scale-95 transition"
            >
              <MessageCircle size={16} /> Book Stay
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
